import { AuthGuard } from '../components/auth/auth.guard';
import { DocumentosComponent } from '../components/documentos/documentos.component';
import { EmpresasComponent } from '../components/empresas/empresas.component';
import { LoginComponent } from '../components/login/login.component';

export class GetRoutes {
  getRoutes(): any {
    return [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'empresas',
        component: EmpresasComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'documentos',
        component: DocumentosComponent,
        canActivate: [AuthGuard],
      },
      {
        path: '**',
        component: DocumentosComponent,
      },
    ];
  }
}
